import React from 'react'

const Header = function(
) {
    return(
        <div className= "header-container">
            <header className = "header">
                <h1 className = "header__title">My Library</h1>
                <h5 className = "header__subtitle">Using google books API</h5>
            </header>
        </div>
    )
}

export default Header